/** @format */

export enum RewardAndOfferStatus {
  Available = 'Available',
  Redeemed = 'Redeemed',
  Expired = 'Expired',
  Invalid = 'Invalid',
  Unauthorized = 'Unauthorized',
  NotIssued = 'NotIssued',
  Unknown = 'Unknown', // not returned by the API, fallback only
}

export enum RewardType {
  Cycle = 'Cycle',
  DollarReward = 'Dollar Reward',
  ScorecardPlus = 'ScorecardPlus',
  PendingScorecardPlus = 'PendingScorecardPlus', // not returned by the API, internal use only
  Unknown = 'Unknown', // not returned by the API, fallback only
}

export enum OfferType {
  GoldPypd = 'GoldPypd',
  ScorecardPlusPypd = 'ScorecardPlusPypd',
  FreeShipping = 'FreeShipping', // not returned by the API, internal use only
  Unknown = 'Unknown', // not returned by the API, fallback only
}

export enum RewardV4Type {
  DollarReward = 'Dollar Reward',
  PointMultiplier = 'Point Multiplier',
  FreeService = 'Other',
  FreeShipping = 'Free Shipping', // not returned from API, internal use only
}

export enum RewardV4Tier {
  ScoreCard = 'ScoreCard',
  ScoreCardPlus = 'ScoreCardPlus',
  ScoreCardGold = 'ScoreCardGold',
  DicksCreditCard = 'DicksCreditCard',
}

export interface Reward {
  active: boolean;
  amount: number;
  expirationDate: string;
  isExpiringSoon?: boolean;
  issueDate: string;
  onlineCode: string;
  redeemed: boolean;
  redeemedDate?: string;
  storeCode: string;
  status?: number;
  rewardStatus?: RewardAndOfferStatus;
  rewardType?: RewardType;
}

export interface SCPlusReward extends Reward {
  type: 'reward' | '3x-points' | 'free-shipping';
  pending?: boolean;
}

export interface Offer {
  expirationDate: string;
  isRedeemed: boolean;
  redeemedDate: string;
  redeemedInStore: boolean;
  rewardCertificateCode: string;
  offerStatus?: RewardAndOfferStatus;
  offerType?: OfferType;
}

export interface RewardOrOffer {
  isScorecardPlus: boolean;
  isGoldOffer: boolean;
  rewardOrOffer: SCPlusReward | Reward | Offer;
}

export interface StoredRewards {
  error: boolean;
  rewards: Reward[];
}

export interface StoredOffers {
  error: boolean;
  offers: Offer[];
}

export interface RewardV4 {
  rewardId: string;
  description: string;
  message: string;
  iconText: string;
  offerCode: string;
  displayTier: RewardV4Tier;
  channels: string[];
  chains: string[];
  status: RewardAndOfferStatus;
  displayToAthlete: boolean;
  expirationDateTime: string;
  redeemedDateTime: string | null;
  pCode: string | null;
  pricingDiscountId: string;
  sendToPricing: boolean;
  unlimitedUses: boolean;
  availableUses: number;
  dollarValue: number;
  rewardType: RewardV4Type;
  issueDate?: string;
  badgeText?: string | null;
}
export interface StoredRewardsV4 {
  error: boolean;
  rewards: RewardV4[];
}
